import BannerDetail from './BannerDetail';

export default BannerDetail;
